"use strict";
exports.__esModule = true;
exports.chart_color_blue_100 = {
  "name": "--pf-v5-chart-color-blue-100",
  "value": "#8bc1f7",
  "var": "var(--pf-v5-chart-color-blue-100, #8bc1f7)"
};
exports["default"] = exports.chart_color_blue_100;